module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": _vm.$store.state.organisationLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-lg-3 txt-lg"
  }, [_c('span', [_vm._v("\n            " + _vm._s(_vm.$store.state.organisationName) + " ")]), _vm._v(" "), _c('span', [_vm._v("(Pan: " + _vm._s(_vm.$store.state.organisationPanVatNo) + ")")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$store.state.organisationAddress))])]), _vm._v(" "), (!this.$store.getters.warehouseId.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6 p-lg-5 fiscal-drop"
  }, [_c('span', {
    staticClass: "txt-lg"
  }, [_vm._v("Fiscal Year:")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "dropDown",
    staticStyle: {
      "margin": "-12% -10% 0% 35%"
    },
    attrs: {
      "options": _vm.fiscalYearLists,
      "optionLabel": "name",
      "id": "fisaclYear",
      "filter": true,
      "placeholder": "Select FiscalYear",
      "showClear": true
    },
    on: {
      "change": _vm.updateFiscalYear
    },
    model: {
      value: (_vm.fyId),
      callback: function($$v) {
        _vm.fyId = $$v
      },
      expression: "fyId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.warehouseId.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-2",
    staticStyle: {
      "margin-left": "6%"
    }
  }, [_c('span', [_vm._v("Store:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$store.state.warehouseData.name))])]) : _vm._e(), _vm._v(" "), (this.$store.getters.counterId.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-2"
  }, [_c('span', [_vm._v("Counter:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$store.state.counterData.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-lg-2"
  }, [_c('div', {
    staticClass: "user-lst"
  }, [_c('div', {
    staticClass: "notification-container"
  }, [_c('div', {
    staticClass: "custom-notification-wrapper",
    on: {
      "click": _vm.toggleNotifications
    }
  }, [_c('i', {
    staticClass: "pi pi-bell custom-bell-icon"
  }), _vm._v(" "), (_vm.unreadNotificationCount > 0) ? _c('span', {
    staticClass: "custom-notification-badge"
  }, [_vm._v("\n                  " + _vm._s(_vm.unreadNotificationCount) + "\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.showNotifications) ? _c('div', {
    staticClass: "notification-dropdown"
  }, [_c('div', {
    staticClass: "notification-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('div', {
    staticClass: "p-checkbox p-component",
    on: {
      "click": _vm.toggleSelectAll
    }
  }, [_c('div', {
    staticClass: "p-checkbox-box",
    class: {
      'p-highlight': _vm.allSelected
    }
  }, [_c('span', {
    staticClass: "p-checkbox-icon pi",
    class: {
      'pi-check': _vm.allSelected
    }
  })])]), _vm._v(" "), (_vm.selectedNotifications.length > 0) ? _c('Button', {
    staticClass: "p-button-text p-button-rounded p-button-sm",
    attrs: {
      "icon": "pi pi-check",
      "title": "Mark selected as read"
    },
    on: {
      "click": _vm.markSelectedAsRead
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.hasMultipleTypes) ? _c('div', {
    staticClass: "notification-filter"
  }, [_c('Dropdown', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "8px"
    },
    attrs: {
      "options": _vm.notificationTypeOptions,
      "optionLabel": "label",
      "optionValue": "value",
      "placeholder": "Select type"
    },
    model: {
      value: (_vm.selectedNotificationType),
      callback: function($$v) {
        _vm.selectedNotificationType = $$v
      },
      expression: "selectedNotificationType"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notification-list"
  }, [(_vm.loadingNotifications) ? _c('div', {
    staticClass: "chart-loading"
  }, [_c('i', {
    staticClass: "pi pi-spin pi-spinner"
  }), _vm._v(" Loading notifications...\n                    ")]) : (_vm.displayedNotifications.length === 0) ? _c('div', {
    staticClass: "no-notifications"
  }, [_vm._v("\n                      No notifications\n                    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedNotifications), function(notification) {
    return _c('div', {
      key: _vm.getNotificationKey(notification),
      class: [
        'notification-item',
        {
          'unread': !notification.notified,
          'selected': _vm.isSelected(notification),
          'removing': _vm.isRemoving(notification),
          'followup': notification.followUpNotificationDTO,
          'unpaid': notification.unpaidInvoiceNotificationDTO
        }
      ]
    }, [_c('div', {
      staticClass: "notification-checkbox",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleSelection(notification)
        }
      }
    }, [_c('div', {
      staticClass: "p-checkbox p-component"
    }, [_c('div', {
      staticClass: "p-checkbox-box",
      class: {
        'p-highlight': _vm.isSelected(notification)
      }
    }, [_c('span', {
      staticClass: "p-checkbox-icon pi",
      class: {
        'pi-check': _vm.isSelected(notification)
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "notification-content",
      on: {
        "click": function($event) {
          return _vm.handleNotificationClick(notification)
        }
      }
    }, [_c('h5', [_vm._v("\n                          " + _vm._s(_vm.getNotificationTitle(notification)) + "\n                          "), (notification.followUpNotificationDTO) ? _c('span', {
      staticClass: "notification-type"
    }, [_vm._v("Follow-up")]) : _vm._e(), _vm._v(" "), (notification.unpaidInvoiceNotificationDTO) ? _c('span', {
      staticClass: "notification-type unpaid"
    }, [_vm._v("Unpaid")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("\n                          " + _vm._s(_vm.formatContactNumber(_vm.getNotificationContact(notification))) + "\n                        ")]), _vm._v(" "), _c('small', [_vm._v("\n                          " + _vm._s(_vm.getNotificationMessage(notification)) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "notification-time"
    }, [_vm._v("\n                          " + _vm._s(_vm.getNotificationTime(notification)) + "\n                        ")])])])
  })], 2), _vm._v(" "), (_vm.showViewAllButton) ? _c('div', {
    staticClass: "notification-footer"
  }, [_c('a', {
    staticClass: "view-all-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.viewAllNotifications.apply(null, arguments)
      }
    }
  }, [_vm._v("View All Notifications")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('user-menu', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "toast",
    attrs: {
      "role": "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('audio', {
    ref: "notifySound",
    attrs: {
      "src": "static/audio/notification.wav",
      "preload": "auto"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-left"
  }, [_c('h4', [_vm._v("Notifications")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "menu-button sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('div', {
    staticClass: "menu-button-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c462676"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashHeader.vue
// module id = 2214
// module chunks = 0